module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Controller[newSelect] .Control_Select":{"template":[{"value":"control_select_new","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"select.container":[{"value":".mc-form-field.dropdown","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"currentValuePlace":[{"value":".current-value","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"templateOptions.openAt":[{"value":"bottom","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"hooks.onStopCreateSelect":[{"value":function () {
var list = document.createElement('ul');
list.setAttribute('class', 'dropdown-list');
fox.each(this.dom('select option'), function (o) {
var item = document.createElement('li');
item.setAttribute('data-value', o.value);
item.setAttribute('class', 'option-item');
if (o.style.display === 'none') item.style.display = 'none';
item.innerHTML = o.innerHTML;
if (o.getAttribute('data-alter-text')) {
item.setAttribute('data-alter-text', o.getAttribute('data-alter-text'));
}
if (this.value !== undefined && o.value == this.value) {
item.setAttribute('class', 'option-item selected');
}
list.appendChild(item);
}.bind(this));
this.dom1(this.getOption('select.container')).appendChild(list);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101024},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.addedToDom.event":[{"value":"addedToDom","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101027},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.addedToDom.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101028},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.addedToDom.callback":[{"value":function () {
require.ensure(['jquery.mCustomScrollbar.min'], function(require) {
require('jquery.mCustomScrollbar.min');
fox.jQuery(this.dom1('.dropdown-list')).mCustomScrollbar({
theme: 'minimal-dark'
});
}.bind(this))
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101038},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.updateDropItems.event":[{"value":"setValue","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101040},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.updateDropItems.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101041},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleWom.updateDropItems.callback":[{"value":function (value) {
$(this.dom('.option-item.selected')).removeClass('selected');
$(this.dom('.option-item[data-value="' + value + '"]')).addClass('selected');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101045},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101048},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.target":[{"value":".option-item","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101049},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.eventChecker":[{"value":function (e) {
var result = !e.currentTarget.classList.contains('disabled');
if (!result) {
e.preventDefault();
e.stopPropagation();
}
return result;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101058},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.selectItem.callback":[{"value":function (el) {
var value = el.getAttribute('data-value');
this.setValue(value);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101062},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.toggleSelect.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101064},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.toggleSelect.target":[{"value":".dropdown","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101065},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}],"handleDom.toggleSelect.callback":[{"value":function (el, alias, w, e) {
var OPENED = 'opened';
var $ = fox.jQuery;
jQuery.Event(e).stopPropagation();
var _handler = function (e) {
var container = $(el);
if (!container.is(e.target) &&
container.has(e.target).length === 0 &&
container.hasClass(OPENED)) {
container.removeClass(OPENED);
$(document.body).off('click', _handler);
}
}
if ($(el).hasClass('disabled'))
return false;
if (!$(el).hasClass(OPENED)) {
$(document.body).on('click', _handler);
$(el).addClass(OPENED);
} else {
$(document.body).off('click', _handler);
$(el).removeClass(OPENED);
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101090},"path":"~.Controller[newSelect] .Control_Select","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/options/controls/customSelect.js
// module id = 50
// module chunks = 5